import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router';
import SettingControlsBlock from '../../../../containers/SettingControlsBlock/SettingControlsBlock';
import NotificationsSettingNavigation from '../../containers/NotificationsSettingNavigation/NotificationsSettingNavigation';
import OrderSystemNotificationOtpBlock from './containers/OrderSystemNotificationOtpBlock/OrderSystemNotificationOtpBlock';
import OrderSystemNotificationRefundBlock from './containers/OrderSystemNotificationRefundBlock/OrderSystemNotificationRefundBlock';
import OrderSystemNotificationSkeletons from './containers/OrderSystemNotificationSkeletons/OrderSystemNotificationSkeletons';
import { orderSystemNotificationStore } from './store';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import './style.scss';

const OrderSystemNotificationScreen: FC = observer((): JSX.Element => {
  useEffect(() => {
    orderSystemNotificationStore.initStore();
  }, []);

  return (
    <div className="d-flex flex-column flex-1">
      <NotificationsSettingNavigation />

      <ScrollableBlock showScrollbar scrollbarSize="normal" className="flex-1 mt-2" scrollClassName="d-flex flex-column gap-30">
        {orderSystemNotificationStore.initial ? (
          <OrderSystemNotificationSkeletons />
        ) : (
          <div className="order-system-notification pr-4">
            <OrderSystemNotificationOtpBlock />
            {/* <OrderSystemNotificationAddressBlock /> */}
            <OrderSystemNotificationRefundBlock />
          </div>
        )}

        <SettingControlsBlock
          setValidation={orderSystemNotificationStore.setValidation}
          onSubmit={orderSystemNotificationStore.updateNotification}
          onReset={orderSystemNotificationStore.resetNotification}
        />
      </ScrollableBlock>

      <LoadingOverlay visible={orderSystemNotificationStore.isLoading} />
      <Prompt when={orderSystemNotificationStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default OrderSystemNotificationScreen;
